module.exports = __webpack_public_path__ + "img/FP (1).b4f2f871.jpeg";